export const GLOBAL_STATE = 'PreModeration'

export const PRE_MODERATION = 'PRE_MODERATION'
export const PRE_MODERATION_ALL = 'PRE_MODERATION_ALL'
export const PRE_MODERATION_ASSIGNED = 'PRE_MODERATION_ASSIGNED'
export const PRE_MODERATION_BY_ID = 'PRE_MODERATION_BY_ID'
export const PRE_MODERATION_HISTORY_CREATE = 'PRE_MODERATION_HISTORY_CREATE'
export const PRE_MODERATION_CHANGE_STATUS = 'PRE_MODERATION_CHANGE_STATUS'
